module.exports = __webpack_public_path__ + "media/images/icon/icons8-Downloading Updates-924c61325e5b792775db0d99f260f36d.png";